// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 745 ? "posthog" : chunkId) + "." + {"15":"67b0ad21","266":"004d671b","474":"b9ddc635","584":"e1e9b57e","595":"8572d4ba","602":"92ae4e78","693":"0a76ebf1","704":"3ba0f606","745":"ab7d0a47"}[chunkId] + ".chunk.js";
};